// import { useQuery } from "react-admin"
import { useDataProvider, useNotify } from 'react-admin';
// import Parse from "Parse"
export const useCertificationsCreate = (payload) => {
    const dataProvider = useDataProvider();
    const notify  = useNotify()
    return {
        createCertification: async(payload) => {
            const data = await dataProvider.create('Certification', {
                data:{
                    certificateName: payload.certificateName
                }
            })
            notify('Add a certification')
            return data
        }
    }
}
